import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h5>{`第三軌：產品與系統設計 🍺`}</h5>
    <p>{`「程式，就該說出使用者的故事 🍻」`}</p>
    <ul>
      <li parentName="ul">{`產品跟程式為何背道而馳？程式碼中為何總是找不到使用者的故事？`}</li>
      <li parentName="ul">{`隕石落下...產品即將面臨新的需求！等等，你說新功能加不進去現有的系統架構中是什麼意思？`}</li>
      <li parentName="ul">{`才有程式，有程式才有架構，團隊需要替產品需求使用更有效的方式塑模，讓產品跟程式持續成長，更快速地接收市場回饋。`}</li>
      <li parentName="ul">{`協產品的價值！無論是產品設計需求端還是軟體架構面，其實都存在了發展已久的方法論能融會貫通，是時候一起發揮影響力了～`}</li>
      <li parentName="ul">{`包含:`}<ol parentName="li">
          <li parentName="ol">{`產品需求釐清與梳理（需求精煉）`}</li>
          <li parentName="ol">{`產品價值流的共識與整理（產品設計）`}</li>
          <li parentName="ol">{`產品系統的服務化解構（DDD 戰略）`}</li>
        </ol></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      